module.exports = __webpack_public_path__ + "static/nagroda-glowna-c312892d716ca23388d26de6068c2e81.svg";